import ApiService from 'services/ApiService/ApiService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import messagingService from 'services/MessagingService/MessagingService';
import {
  GENERIC_ERROR,
  ONLINE_FAVORITES,
  ONLINE_FRIENDS,
  ONLINE_FRIENDS_FAVORITES,
  ONLINE_FRIENDS_FAVORITES_COUNT,
} from 'services/MessagingService/EventNames';
import { QUICK_FILTERS } from 'enum/helpers';
import parseCatch from 'utils/parseCatch';


const WEBCHAT_HOST = ConfigurationService.get(ConfigurationKeys.WEB_CHAT_HOST);
const ONLINE_FRIENDS_FAVORITES_URL = `${WEBCHAT_HOST}requestChatlessPresenceInformation`;

class UserFriendsFavoritesService {
  constructor() {
    this.messagingService = messagingService();
  }

  getOnlineFriendsFavoritesCount = async(params) => {
    try {
      const responses = await this._fetchFriendsFavorites(params);
      this.messagingService.emit(
        ONLINE_FRIENDS_FAVORITES_COUNT,
        responses.map((res) => res.data)
      );
    } catch (error) {
      this.messagingService.emit(GENERIC_ERROR, error.data);
      parseCatch(error);
    }
  };

  getOnlineFriends = async(params) => {
    try {
      const queryParams = { ...params, type: QUICK_FILTERS.friends };
      const response = await ApiService.get(ONLINE_FRIENDS_FAVORITES_URL, { params: queryParams });
      this.messagingService.emit(ONLINE_FRIENDS, response.data);
    } catch (error) {
      this.messagingService.emit(GENERIC_ERROR, error.data);
      parseCatch(error);
    }
  };

  getOnlineFavorites = async(params) => {
    try {
      const queryParams = { ...params, type: QUICK_FILTERS.favorites };
      const response = await ApiService.get(ONLINE_FRIENDS_FAVORITES_URL, { params: queryParams });
      this.messagingService.emit(ONLINE_FAVORITES, response.data);
    } catch (error) {
      this.messagingService.emit(GENERIC_ERROR, error.data);
      parseCatch(error);
    }
  };

  getOnlineFriendsFavorites = async(params) => {
    try {
      const responses = await this._fetchFriendsFavorites(params);
      this.messagingService.emit(
        ONLINE_FRIENDS_FAVORITES,
        responses.map((res) => res.data)
      );
    } catch (error) {
      this.messagingService.emit(GENERIC_ERROR, error.data);
      parseCatch(error);
    }
  };

  _fetchFriendsFavorites = (params) => {
    const friendsParams = { ...params, type: QUICK_FILTERS.friends };
    const friends = ApiService.get(ONLINE_FRIENDS_FAVORITES_URL, { params: friendsParams });

    const favoritesParams = { ...params, type: QUICK_FILTERS.favorites };
    const favorites = ApiService.get(ONLINE_FRIENDS_FAVORITES_URL, { params: favoritesParams });

    return Promise.all([friends, favorites]);
  };
}

export default new UserFriendsFavoritesService();
